exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:979px){#main-content[data-v-6effc3fb]{background-size:100%!important}}#main-content[data-v-6effc3fb]{background:url(\"/src/assets/images/bg/restricted-gb.jpg\");height:100%;width:100%;background-size:50vw;background-position-y:center;background-repeat:no-repeat;background-position-x:center}", ""]);

// exports
